var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9734 53.8068C93 50.7802 93 45.909 93 36.1667C93 26.4243 93 21.5531 89.9734 18.5266M89.9734 53.8068C86.9469 56.8333 82.0757 56.8333 72.3333 56.8333H51.6667C41.9243 56.8333 37.0531 56.8333 34.0266 53.8068M89.9734 53.8068C89.9734 53.8068 89.9734 53.8068 89.9734 53.8068ZM89.9734 18.5266C86.9469 15.5 82.0757 15.5 72.3333 15.5L51.6667 15.5C41.9243 15.5 37.0531 15.5 34.0266 18.5266M89.9734 18.5266C89.9734 18.5266 89.9734 18.5266 89.9734 18.5266ZM34.0266 18.5266C31 21.5531 31 26.4243 31 36.1667C31 45.909 31 50.7802 34.0266 53.8068M34.0266 18.5266C34.0266 18.5266 34.0266 18.5266 34.0266 18.5266ZM34.0266 53.8068C34.0266 53.8068 34.0266 53.8068 34.0266 53.8068Z",
    stroke: "#222222",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1663 36.1667C67.1663 39.0201 64.8531 41.3333 61.9997 41.3333C59.1462 41.3333 56.833 39.0201 56.833 36.1667C56.833 33.3132 59.1462 31 61.9997 31C64.8531 31 67.1663 33.3132 67.1663 36.1667Z",
    stroke: "#222222",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 31C84.4396 31 77.5 24.0604 77.5 15.5",
    stroke: "#222222",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41.3333C84.4396 41.3333 77.5 48.2728 77.5 56.8333",
    stroke: "#222222",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31C39.5604 31 46.5 24.0604 46.5 15.5",
    stroke: "#222222",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41.3333C39.5604 41.3333 46.5 48.2728 46.5 56.8333",
    stroke: "#222222",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 105.34H37.5093C42.7321 105.34 48.0111 105.884 53.094 106.931C62.0853 108.784 71.552 109.008 80.6356 107.538C85.1143 106.813 89.5176 105.704 93.5033 103.78C97.1014 102.044 101.509 99.5957 104.469 96.8538C107.426 94.1158 110.504 89.6348 112.689 86.1321C114.563 83.1285 113.657 79.4436 110.693 77.2056C107.401 74.7197 102.515 74.7202 99.2235 77.2068L89.8864 84.2601C86.2677 86.9937 82.3149 89.5101 77.606 90.2611C77.0399 90.3514 76.4465 90.4337 75.8275 90.5054M75.8275 90.5054C75.6412 90.527 75.4525 90.5477 75.2615 90.5673M75.8275 90.5054C76.5808 90.344 77.3288 89.8795 78.0306 89.267C81.3538 86.3665 81.564 81.4782 78.6805 78.2394C78.0115 77.4879 77.2286 76.8612 76.3582 76.3421C61.9053 67.7217 39.4183 74.2873 25.833 83.9217M75.8275 90.5054C75.639 90.5458 75.4501 90.5673 75.2615 90.5673M75.2615 90.5673C72.5575 90.8449 69.394 90.9166 65.8838 90.5852",
    stroke: "#222222",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.333,
    y: 72.3333,
    width: 15.5,
    height: 41.3333,
    rx: 1.5,
    stroke: "#222222",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandMoney);
export default __webpack_public_path__ + "static/media/Hand Money.bd65027a50f12d220d470202480d7a17.svg";
export { ForwardRef as ReactComponent };